<template>
  <div class="box">
    <Header title="订单详情"></Header>
    <div class="show-box">
      <div class="title-card"></div>
      <div class="info-detail-box">
        <div class="detail-title">订单信息</div>
        <div class="detail-icon">
          <img class="icon-img" src="../assets/images/order.png" alt />
        </div>
        <div class="detail-line2">
          <div class="detail-line">
            <div class="detail-line-title">订单编号</div>
            <div class="detail-line-content" v-text="orderInfo.codeno"></div>
          </div>
        </div>
        <div class="detail-line2">
          <div class="detail-line">
            <div class="detail-line-title">订单状态</div>
            <div
              class="detail-line-content"
              v-text="orderInfo.orderStateName"
            ></div>
          </div>
          <div class="detail-line-right">
            <div class="detail-line-title">DBU区域名称</div>
            <div class="detail-line-content" v-text="orderInfo.cshName"></div>
          </div>
        </div>
        <div class="detail-line2">
          <div class="detail-line">
            <div class="detail-line-title">下单时间</div>
            <div class="detail-line-content" v-text="orderInfo.orderDate"></div>
          </div>
          <div class="detail-line-right">
            <div class="detail-line-title">客户编号</div>
            <div
              class="detail-line-content"
              v-text="orderInfo.customerNo"
            ></div>
          </div>
        </div>
        <div class="detail-line2">
          <div class="detail-line">
            <div class="detail-line-title">订单类型</div>
            <div
              class="detail-line-content"
              v-text="orderInfo.orderTypeName"
            ></div>
          </div>
          <div class="detail-line-right">
            <div class="detail-line-title">BILL TO</div>
            <div
              class="detail-line-content"
              v-text="orderInfo.billToLocation"
            ></div>
          </div>
        </div>
        <div class="detail-line2">
          <div class="detail-line">
            <div class="detail-line-title">发货仓库</div>
            <div
              class="detail-line-content"
              v-text="orderInfo.warehouseName"
            ></div>
          </div>
          <div class="detail-line-right">
            <div class="detail-line-title">SHIP TO</div>
            <div
              class="detail-line-content"
              v-text="orderInfo.shipToLocation"
            ></div>
          </div>
        </div>
        <div class="detail-line2">
          <div class="detail-line">
            <div class="detail-line-title">客户登录名</div>
            <div
              class="detail-line-content"
              style="color: #c29f25"
              v-text="orderInfo.displayName"
              @click="clickToPageUserCenterDetail(orderInfo.userCode)"
            ></div>
          </div>
          <div class="detail-line-right">
            <div class="detail-line-title">加急费</div>
            <div
              class="detail-line-content"
              v-text="orderInfo.emergencyFee"
            ></div>
          </div>
        </div>
        <div class="detail-line2">
          <div class="detail-line">
            <div class="detail-line-title">商品总金额</div>
            <div
              class="detail-line-content"
              v-text="orderInfo.productMoney"
            ></div>
          </div>
          <div class="detail-line-right">
            <div class="detail-line-title">订单总金额</div>
            <div
              class="detail-line-content"
              v-text="orderInfo.orderAmount"
            ></div>
          </div>
        </div>
        <div class="detail-line2">
          <div class="detail-line">
            <div class="detail-line-title">优惠金额</div>
            <div
              class="detail-line-content"
              :style="{ color: orderInfo.deductionAmount < 0  ? '#da291c' : '#000000' }"
              v-text="orderInfo.deductionAmount"
            ></div>
          </div>
          <div class="detail-line-right">
            <div class="detail-line-title">付款总金额</div>
            <div class="detail-line-content" v-text="orderInfo.payAmt"></div>
          </div>
        </div>
      </div>
      <div class="info-detail-box" style="margin-top: 20px">
        <div class="detail-title">收货信息</div>
        <div class="detail-icon">
          <img class="icon-img" src="../assets/images/user.png" alt />
        </div>
        <div class="detail-line2">
          <div class="detail-line" style="width: 80%">
            <div class="detail-line-title">收货人</div>
            <div
              class="detail-line-content"
              v-text="orderInfo.shipPerson"
            ></div>
          </div>
        </div>
        <div class="detail-line2">
          <div class="detail-line" style="width: 100%">
            <div class="detail-line-title">联系方式</div>
            <div class="detail-line-content" v-text="orderInfo.shipPhone"></div>
          </div>
        </div>
        <div class="detail-line2">
          <div class="detail-line" style="width: 100%">
            <div class="detail-line-title">收货地址</div>
            <div
              class="detail-line-content"
              v-text="
                orderInfo.shipProvince +
                orderInfo.shipCity +
                orderInfo.shipRegion +
                orderInfo.shipTerritory
              "
            ></div>
          </div>
        </div>
      </div>
      <div class="info-detail-box" style="margin-top: 20px">
        <div class="detail-title">LINES(点击零件号/零件名查询库存)</div>
        <div class="detail-icon">
          <img
            class="icon-img"
            src="../assets/images/partInquriyDetail-1.png"
            alt
          />
        </div>
        <van-list class="list-ul">
          <div class="list-line">
            <div class="list-index-title"></div>
            <div class="list-partNo-title">零件号</div>
            <div class="list-name-title">零件名</div>
            <div class="list-num-title">数量</div>
            <div class="list-price-title">单价</div>
          </div>
          <li
            class="list-li"
            v-for="(item, index) in orderInfo.orderdetailSnapShotVoList"
            :key="index"
            @click="clickToPageDetail(item.productId)"
          >
            <div class="list-index-content" v-text="index + 1"></div>
            <div class="list-partNo-content" v-text="item.productId"></div>
            <div class="list-name-content" v-text="item.catalogDesc"></div>
            <div class="list-num-content" v-text="item.amount"></div>
            <div class="list-price-content" v-text="item.purchasePrice"></div>
          </li>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderDetail } from "@/api/orderDetail";
import { STATUS_CODE_OK } from "@/config";
import { mapActions } from "vuex";
import Header from "@/components/Header";
export default {
  name: "orderDetail",
  data() {
    return {
      orderInfo: {},
    };
  },
  mounted() {
    // 获取页面初始信息
    this.getInitInfo();
  },
  methods: {
    async getInitInfo() {
      let { data } = await getOrderDetail({
        codeno: this.$route.params.orderNo, //订单号
      });
      if (data.resultStatusCode === STATUS_CODE_OK) {
        this.orderInfo = data.orderdetailSnapShotVoList;
        this.orderInfo.emergencyFee = parseFloat(this.orderInfo.emergencyFee).toFixed(2); //加急费
        this.orderInfo.productMoney = parseFloat(this.orderInfo.productMoney).toFixed(2); //商品总金额
        this.orderInfo.orderAmount = parseFloat(this.orderInfo.orderAmount).toFixed(2);   //订单总金额
        this.orderInfo.deductionAmount = parseFloat(this.orderInfo.deductionAmount).toFixed(2); //优惠金额
        this.orderInfo.payAmt = parseFloat(this.orderInfo.payAmt).toFixed(2); //付款总金额
      }
    },
    //点击客户登录名跳转用户详情页面
    clickToPageUserCenterDetail(userCode) {
      this.$router.push({
        name: "userCenterDetail",
        params: {
          userCode: userCode,
        },
      });
    },
    //点击List数据跳转库存详情页面
    clickToPageDetail(id) {
      this.setPartNo(id);
      this.$router.push({
        name: "partInquriyDetail",
      });
    },
    ...mapActions(["setPartNo"]),
  },
  components: {
    Header,
  },
};
</script>
<style lang="scss" scoped>
.box {
  height: 100%;
  .info-detail-box {
    width: 100%;
    border-radius: 20px;
    padding: 20px;
    .detail-title {
      width: 65%;
      text-align: left;
      border-bottom: 1px solid #dcdcdc;
      font-size: 14px;
      font-weight: bold;
      color: #000000;
      padding-bottom: 5px;
    }
    .detail-icon {
      position: absolute;
      right: 0px;
      top: 0px;
      .icon-img {
        width: 80px;
      }
    }
    .detail-line2 {
      display: flex;
      .detail-line {
        padding: 10px 10px 0px 0px;
        text-align: left;
        width: 50%;
      }
      .detail-line-right {
        padding: 10px 0px 0px 20px;
        text-align: left;
        width: 50%;
      }

      .detail-line-title {
        color: #999999;
        font-size: 12px;
        padding-bottom: 2px;
      }
      .detail-line-content {
        min-height: 18px;
        font-size: 12px;
        color: #000000;
        padding-right: 10px;
        -webkit-box-orient: vertical;
        word-wrap: break-word;
      }
      .detail-line-content-1 {
        min-height: 18px;
        font-size: 12px;
        color: green;
        padding-right: 10px;
      }
      .detail-line-content-2 {
        min-height: 18px;
        font-size: 12px;
        color: #da291c;
        padding-right: 10px;
      }
    }
  }
  .list-line {
    display: flex;
    color: #999999;
    font-size: 12px;
    padding-bottom: 2px;
    align-items: center;
    text-align: left;
    padding-top: 10px;
    .list-index-title {
      width: 8%;
    }
    .list-partNo-title {
      width: 20%;
    }
    .list-name-title {
      width: 37%;
    }
    .list-num-title {
      width: 15%;
    }
    .list-price-title {
      width: 20%;
    }
  }
  .list-ul {
    border-radius: 0px 0px 20px 20px;
    font-size: 10px;
    margin: 20px 0px;
    .list-li {
      display: flex;
      height: 50px;
      align-items: center;
      text-align: left;
      word-break: break-all;
      .list-index-content {
        width: 8%;
        padding-right: 5px;
      }
      .list-partNo-content {
        width: 20%;
        color: #c29f25;
        padding-right: 5px;
      }
      .list-name-content {
        width: 37%;
        color: #c29f25;
        padding-right: 10px;
      }
      .list-num-content {
        width: 15%;
        color: #000;
        padding-right: 5px;
      }
      .list-price-content {
        width: 20%;
        color: #000;
      }
    }
  }
}
</style>